import { render } from "./Content.vue?vue&type=template&id=5c70a957"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=5c70a957&lang=scss"
script.render = render

export default script